import React, { Component } from 'react'
import { observable, computed } from 'mobx'
import {
  i18nTranslate,
  enableAccountSettings,
  getLocaleCodeFromUrl,
} from 'src/utils'
import { Row, Col, Container } from 'react-bootstrap'
import MobileMenu from './MobileMenuNuskin/MobileMenu'
import { APPConfig, convertToBoolean } from 'config/appConfig'
import { customerContainer } from 'src/models'
import SearchInput from './SearchBox'
import RedesignNavtab from './RedesignNavtab'
import { enableNewFeature } from 'src/utils/commonUtils'
import { NavigationImage } from '@nuskin/foundation-ui-components/src/common/image/NsNextImage.stories'
import { CategoryMenu as DefaultCategoryMenu } from '../NuskinHeader/CategoryMenu'
import { CategoryMenu as MainMenuCategory } from '../NuskinHeader/MainMenuSection/CategoryMenu'
import {
  createAdditionalProfessionalCareItems,
  createAdditionalShopItems,
  getHardCodedMenusIN,
  getProfessionalCareTranslations,
  getShopTranslations,
} from '../deps'

class MegaMenuSection extends Component {
  nameSpace = 'ssr-resource'
  middleHeader = ''
  categoryWidth = '66%'
  hardcodedList = []
  mobileHardcodedList = []
  @observable searchOpen = false

  constructor(props, context) {
    super(props, context)
    const getFooterDataFromCS =
      APPConfig?.getAppConfig()?.enableImpactSectionFromCS === 'true'
    const enableOurCompanyCategory =
      APPConfig?.getAppConfig()?.enableOurCompanyCategory === 'true'
    if (!getFooterDataFromCS) {
      this.initializeHardcodedMenus()
    }
  }

  componentDidMount() {
    const children = this.middleHeader?.children
    let totalWidth = 0
    if (children !== undefined) {
      Array.from(children, child => (totalWidth += child.offsetWidth))
    }
    this.categoryWidth = this.middleHeader?.clientWidth - totalWidth - 48
  }

  initializeHardcodedMenus = () => {
    const enableOurCompanyCategory =
      APPConfig?.getAppConfig()?.enableOurCompanyCategory === 'true'
    if (enableOurCompanyCategory) {
      const { hardcodedList, mobileHardcodedList } = getHardCodedMenusIN(
        this.baseUrl,
        this.nameSpace
      )
      this.hardcodedList = hardcodedList
      this.mobileHardcodedList = mobileHardcodedList
    } else {
      this.getHardCodedMenus()
    }
  }

  toggleSearch = () => {
    this.searchOpen = !this.searchOpen
  }

  getHardCodedMenus = () => {
    const ourImpactText = i18nTranslate('megamenu.ourimpact', 'Personal Care', {
      nameSpace: this.nameSpace,
    })
    const sustainabilityText = i18nTranslate(
      'megamenu.ourimpact.sustainability',
      'Sustainability',
      { nameSpace: this.nameSpace }
    )
    const socialImpactText = i18nTranslate(
      'megamenu.ourimpact.socialimpact',
      'Social Impact',
      { nameSpace: this.nameSpace }
    )
    this.hardcodedList = [
      {
        properties: {
          meta_title: ourImpactText,
          name: ourImpactText,
          description: ourImpactText,
        },
        parentId: 'top',
        subCategories: [
          {
            properties: {
              meta_title: '',
              name: '',
              description: '',
            },
            parentId: 'top',
            subCategories: [
              {
                properties: {
                  meta_title: sustainabilityText,
                  name: sustainabilityText,
                  description: sustainabilityText,
                },
                parentId: 'ourimpact',
                identifier: 'sustainability',
              },
              {
                properties: {
                  meta_title: socialImpactText,
                  name: socialImpactText,
                  description: socialImpactText,
                },
                parentId: 'ourimpact',
                identifier: 'socialimpact',
              },
            ],
            identifier: 'ourimpact',
          },
        ],
        identifier: 'ourimpact',
        isDummyCategory: true,
      },
    ]

    this.mobileHardcodedList = JSON.parse(JSON.stringify(this.hardcodedList))
    this.mobileHardcodedList[0]['subCategories'] =
      this.mobileHardcodedList?.[0].subCategories?.[0]?.subCategories || []
  }

  renderCategoryMenu(categoryResponseList) {
    if (enableNewFeature('enableRedesignMainMenu')) {
      return (
        <MainMenuCategory
          categoryResponse={categoryResponseList}
          navigationData={this.props.navigationData}
        />
      )
    }
    return <DefaultCategoryMenu categoryResponse={categoryResponseList} />
  }

  getFinalCategoryResponseList = (apiCategories, hardcodedList) => {
    const enableAdditionalCategoriesInMenu =
      APPConfig?.getAppConfig()?.enableAdditionalCategoriesInMenu === 'true'

    let modifiedCategories = apiCategories

    if (enableAdditionalCategoriesInMenu) {
      const additionalShopItems = createAdditionalShopItems()
      const additionalProfessionalCareItems =
        createAdditionalProfessionalCareItems()

      modifiedCategories = apiCategories.map(category => {
        if (
          category.identifier === 'shop_beauty_wellness' ||
          category.identifier === 'shop'
        ) {
          return {
            ...category,
            subCategories: [
              additionalShopItems,
              ...(category.subCategories || []),
            ],
          }
        }
        if (
          category.identifier === 'serenu' ||
          category.identifier === 'serenu_professional_skin_care'
        ) {
          return {
            ...category,
            subCategories: [
              additionalProfessionalCareItems,
              ...(category.subCategories || []),
            ],
          }
        }
        return category
      })
      return [...modifiedCategories, ...hardcodedList]
    }
    return [...apiCategories, ...hardcodedList]
  }

  render() {
    const isGuestB2B = customerContainer.isGuestB2B
    const borderClass = enableAccountSettings() ? 'mfe-nav-border' : ''
    const navigationContainerClass = enableNewFeature('enableRedesignMainMenu')
      ? 'navigationContainerNew'
      : 'navigationContainer'
    const categoryResponseList = this.getFinalCategoryResponseList(
      this.props?.categoryResponse?.category?.subCategories || [],
      this.hardcodedList
    )
    const mobileCategoryResponseList = this.getFinalCategoryResponseList(
      this.props?.categoryResponse?.category?.subCategories || [],
      this.mobileHardcodedList
    )

    return (
      <>
        <Container
          fluid
          className={`navigationWrapper d-none d-lg-block ${enableNewFeature('enableRedesignMainMenu') ? 'p-custom-32' : 'px-3'} ${borderClass}`}>
          <Row>
            <Col>
              <div
                className={`${navigationContainerClass} ${enableNewFeature('enableRedesignMainMenu') ? '' : 'px-lg-3'}`}>
                <div className="navigationContainerItem catNav">
                  {this.renderCategoryMenu(categoryResponseList)}
                </div>
                <div
                  className="navigationContainerItem searchBox ml-auto"
                  style={{ minWidth: '200px' }}>
                  <SearchInput {...this.props} />
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        {!isGuestB2B && (
          <MobileMenu
            {...this.props}
            data={this.props.data}
            categoryResponse={{
              category: { subCategories: mobileCategoryResponseList },
            }}
            {...(enableNewFeature('enableNewHeaderNavigation') && {
              headerNavigation: this.props.headerNavigation,
              regionSelector: this.props.regionSelector,
            })}
            {...(enableNewFeature('enableRedesignMainMenu') && {
              navigationData: this.props.navigationData,
            })}
            isNuskinHeader
          />
        )}
      </>
    )
  }
}

export default MegaMenuSection
